module.exports = __webpack_public_path__ + "img/multiplier9_freespins.63e4f4d3.png";